@let profile = profileStateService.select('profile') | async;
@let profilePhoto = profileStateService.select('profilePhotoUrl') | async;
@let user = user$ | async;
@let organization = organization$ | async;
@let userFirstName = userFirstName$ | async;
@let userRole = userRole$ | async;

<div (click)="onViewDropDown()">
    <user-login-status
        [user]="
            $safeNavigationMigration(user?.firstName) +
            ' ' +
            $safeNavigationMigration(user?.lastName)
        "
        [profilePhoto]="profilePhoto ?? ''"
        [verifiedAt]="$safeNavigationMigration(user?.verifiedAt)"
        [userFirstName]="userFirstName"
        [userRole]="userRole ?? ''" />
</div>

@if (isVisible()) {
    <div
        #dropdown
        id="profileDropDown"
        class="bg-color-container absolute top-15 right-3 z-[999] w-64 rounded-2xl border border-gray-100 p-2 shadow-[0_8px_30px_rgba(0,0,0,0.06)] dark:border-gray-700">
        <!-- User Info -->
        <div class="px-3 py-2">
            <div class="flex items-center gap-2">
                <p class="text-card-title truncate font-semibold">
                    {{ profile?.firstName }}
                    {{ profile?.lastName }}
                </p>

                @if (user?.verifiedAt) {
                    <i class="pi pi-check-circle text-primary text-sm"></i>
                }
            </div>

            <div
                class="text-card-label mt-1 inline-flex max-w-full items-center gap-1 text-sm">
                <i class="pi pi-building text-sm"></i>

                <span class="truncate">
                    {{
                        $safeNavigationMigration(organization?.name)
                            | textSlice: 26
                    }}
                </span>
            </div>
        </div>

        <div class="my-1 border-t border-gray-100"></div>

        <!-- Actions -->
        <div class="flex flex-col gap-0.5">
            <button
                (click)="onNavigate('/easy/profile')"
                class="text-card-text flex cursor-pointer items-center gap-2 rounded-xl px-3 py-2 text-sm font-medium transition-all duration-200 hover:bg-gray-100">
                <i class="pi pi-user text-xs"></i>

                <span>Profile</span>
            </button>

            <button
                (click)="logout()"
                class="flex cursor-pointer items-center gap-2 rounded-xl px-3 py-2 text-sm font-medium text-red-600 transition-all duration-200 hover:bg-red-50">
                <i class="pi pi-sign-out text-xs"></i>

                <span>Logout</span>
            </button>
        </div>
    </div>
}
